module.exports = __webpack_public_path__ + "static/media/info.4e5817e8.svg";